import React from "react";

interface RadioCardProps {
  value: string;
  label: string;
  children: React.ReactNode;
  selectedOption: string;
  setSelectedOption: (value: any) => void;
  disabled?: boolean;
  icon: React.ReactNode;
  className?: string;
}

export const RadioCard: React.FC<RadioCardProps> = ({
  value,
  label,
  children,
  selectedOption,
  setSelectedOption,
  disabled = false,
  icon,
  className,
}) => {
  const isSelected = selectedOption === value;

  return (
    <div
      className={`mt-4 p-4 border-2 rounded-lg transition-all ${
        isSelected
          ? "border-yellow-400 bg-yellow-50/50"
          : "border-gray-200 bg-white"
      } ${
        disabled
          ? "opacity-50 cursor-not-allowed"
          : "hover:border-yellow-300 cursor-pointer"
      } ${className}`}
      onClick={() => !disabled && setSelectedOption(value)}
    >
      <div className="flex items-start">
        {/* Hidden radio input for accessibility */}
        <input
          type="radio"
          name="cvOption"
          value={value}
          checked={isSelected}
          onChange={() => !disabled && setSelectedOption(value)}
          className="hidden"
          disabled={disabled}
        />

        <div className="flex-shrink-0 text-gray-500 pt-0.5">{icon}</div>
        <div className="ml-4 w-full">
          <span
            className={`font-bold ${
              isSelected ? "text-gray-900" : "text-gray-700"
            }`}
          >
            {label}
          </span>
        </div>
      </div>

      {/* Collapsible content area that appears when selected */}
      <div
        className={`transition-all duration-300 ease-in-out overflow-hidden ${
          isSelected ? "max-h-96 mt-2" : "max-h-0"
        }`}
      >
        {/* We add margin-left to align the content with the label text */}
        <div className="ml-10 text-sm text-gray-600 pt-1">{children}</div>
      </div>
    </div>
  );
};
